// extracted by mini-css-extract-plugin
module.exports = {"container":"policy_info_section_container__1X38x","title":"policy_info_section_title__1VXgd"};